function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalSignature({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.779,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 33.122,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.527,
    y: 401.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 8.693,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.586,
    y: 389.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.192,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 43.193,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.556,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 6.333,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.471,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 93.676,
    height: 0.25
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M238.401,337.8H45.302c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708 h193.099c3.146,0,5.707,2.561,5.707,5.708v271.432C244.108,335.239,241.547,337.8,238.401,337.8z M45.302,55.203 c-3.01,0-5.458,2.448-5.458,5.458v271.432c0,3.01,2.448,5.458,5.458,5.458h193.099c3.009,0,5.457-2.448,5.457-5.458V60.66 c0-3.009-2.448-5.458-5.457-5.458H45.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M454.698,337.8H261.599c-3.146,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.561-5.708,5.707-5.708 h193.099c3.148,0,5.708,2.561,5.708,5.708v271.432C460.406,335.239,457.845,337.8,454.698,337.8z M261.599,55.203 c-3.009,0-5.457,2.448-5.457,5.458v271.432c0,3.01,2.448,5.458,5.457,5.458h193.099c3.01,0,5.458-2.448,5.458-5.458V60.66 c0-3.009-2.448-5.458-5.458-5.458H261.599z"
  })), /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    style: {
      fill: "#EBEBEB"
    },
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M119.331,314.75c-0.845-9.658-10.704-13.273-22.387-12.251 c-11.682,1.022-20.764,6.295-19.919,15.953L119.331,314.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M96.558,298.085c5.422-0.474,7.153-5.054,6.678-10.476c-0.474-5.422-2.974-9.632-8.396-9.157 c-5.422,0.474-7.153,5.054-6.678,10.476C88.636,294.35,91.136,298.56,96.558,298.085z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M340.1,108.971c0.262,2.99-1.95,5.626-4.94,5.887c-2.99,0.262-5.626-1.95-5.887-4.94 c-0.262-2.99,1.95-5.626,4.94-5.888C337.203,103.769,339.839,105.981,340.1,108.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M370.173,106.34c0.262,2.99-1.95,5.626-4.94,5.887c-2.99,0.262-5.626-1.95-5.888-4.94 c-0.262-2.99,1.95-5.626,4.94-5.888C367.276,101.138,369.911,103.35,370.173,106.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M400.246,103.709c0.262,2.99-1.95,5.626-4.94,5.888c-2.99,0.262-5.626-1.95-5.888-4.94 c-0.262-2.99,1.95-5.626,4.94-5.888C397.348,98.507,399.984,100.719,400.246,103.709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M342.782,139.624c0.262,2.99-1.95,5.626-4.94,5.888c-2.99,0.262-5.626-1.95-5.888-4.94 c-0.262-2.99,1.95-5.626,4.94-5.887C339.885,134.422,342.521,136.633,342.782,139.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M372.855,136.992c0.262,2.99-1.95,5.626-4.94,5.888c-2.99,0.262-5.626-1.95-5.888-4.94 c-0.262-2.99,1.95-5.626,4.94-5.888C369.957,131.791,372.593,134.003,372.855,136.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M402.928,134.361c0.262,2.99-1.95,5.626-4.94,5.887c-2.99,0.262-5.626-1.95-5.888-4.94 c-0.262-2.99,1.95-5.626,4.94-5.888C400.03,129.16,402.666,131.372,402.928,134.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M345.464,170.276c0.262,2.99-1.95,5.626-4.94,5.888c-2.99,0.262-5.626-1.95-5.887-4.94 c-0.262-2.99,1.95-5.626,4.94-5.888C342.566,165.074,345.202,167.286,345.464,170.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M375.537,167.645c0.262,2.99-1.95,5.626-4.94,5.888c-2.99,0.262-5.626-1.95-5.888-4.94 c-0.262-2.99,1.95-5.626,4.94-5.887C372.639,162.443,375.275,164.655,375.537,167.645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M405.609,165.014c0.262,2.99-1.95,5.626-4.94,5.887s-5.626-1.95-5.888-4.94 c-0.262-2.99,1.95-5.626,4.94-5.887C402.712,159.812,405.348,162.024,405.609,165.014z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M399.112,166.779l-61.786,5.406l54.782-66.567l-56.13,4.911c-0.656,0.057-1.234-0.428-1.291-1.084 l0,0c-0.057-0.656,0.428-1.234,1.084-1.291l61.786-5.406l-54.782,66.567l56.13-4.911c0.656-0.057,1.234,0.428,1.291,1.083l0,0 C400.253,166.143,399.768,166.722,399.112,166.779z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M400.059,285.606c-0.204-0.589-0.731-1.026-1.353-1.067c-2.834-0.19-5.228-1.25-7.123-3.153 c-2.471-2.481-3.924-6.257-4.159-10.74c-0.044-0.835-0.744-1.486-1.58-1.491h0c-0.926-0.006-1.664,0.776-1.614,1.7 c0.285,5.258,2.063,9.755,5.085,12.79c2.361,2.371,5.406,3.76,8.876,4.063c0.06,0.005,0.138,0.012,0.228,0.019 C399.57,287.818,400.437,286.696,400.059,285.606z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M396.864,304.8c-13.254-1.16-22.811-10.193-25.836-24.289c-0.193-0.899,0.38-1.784,1.286-1.941 l0,0c0.837-0.145,1.655,0.385,1.832,1.216c2.71,12.677,11.218,20.795,22.996,21.826c12.917,1.13,26.79-7.368,29.275-28.792 c0.101-0.868,0.858-1.509,1.728-1.433l0,0c0.891,0.078,1.559,0.873,1.454,1.761C427.218,293.347,413.937,306.294,396.864,304.8z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M371.86,266.462L371.86,266.462c-0.891-0.078-1.559-0.873-1.454-1.761 c2.382-20.2,15.664-33.146,32.736-31.653c14.959,1.309,25.045,12.508,26.616,29.378c0.083,0.891-0.608,1.667-1.501,1.72 l-0.003,0c-0.871,0.052-1.606-0.606-1.689-1.474c-1.442-15.199-10.418-25.274-23.703-26.436 c-12.917-1.13-26.79,7.367-29.275,28.792C373.487,265.897,372.73,266.538,371.86,266.462z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M397.515,296.232c-2.464-0.216-4.775-0.791-6.896-1.718c-0.863-0.377-1.219-1.416-0.768-2.243 l0,0c0.393-0.721,1.27-1.033,2.021-0.702c1.994,0.876,4.198,1.391,6.573,1.521c9.797,0.561,20.137-6.378,21.15-23.144 c0.624-10.326-2.913-18.667-9.517-22.656c-0.708-0.428-0.971-1.323-0.606-2.065l0,0c0.415-0.843,1.467-1.154,2.271-0.669 c7.642,4.614,11.746,14.028,11.047,25.583c-0.977,16.167-11.064,26.919-24.529,26.148 C398.012,296.271,397.762,296.253,397.515,296.232z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M383.266,286.258c-0.774,0.529-1.832,0.282-2.302-0.53c-2.835-4.904-4.161-11.227-3.75-18.018 c0.935-15.465,10.207-25.976,22.798-26.183c0.934-0.015,1.689,0.766,1.636,1.699l0,0.004c-0.048,0.831-0.725,1.485-1.557,1.501 c-9.337,0.184-18.718,7.242-19.681,23.172c-0.374,6.184,0.809,11.891,3.345,16.255 C384.171,284.875,383.951,285.79,383.266,286.258L383.266,286.258z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M405.13,284.95L405.13,284.95c-0.326-0.741-0.041-1.597,0.653-2.015 c4.205-2.532,6.788-7.846,6.832-14.251c0.035-5.131-1.454-9.471-4.193-12.221c-2.112-2.122-4.843-3.19-8.116-3.184 c-4.93,0.013-8.922,2.714-11.134,7.467c-0.348,0.748-1.214,1.102-1.989,0.817l0,0c-0.881-0.324-1.3-1.339-0.902-2.189 c2.736-5.839,7.869-9.28,14.016-9.297c4.099-0.006,7.694,1.417,10.393,4.127c3.346,3.36,5.166,8.509,5.125,14.501 c-0.051,7.559-3.235,13.895-8.421,16.996C406.578,286.189,405.513,285.821,405.13,284.95z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M393.609,273.193c-0.909,0.365-1.926-0.163-2.159-1.115c-0.106-0.433-0.194-0.879-0.263-1.338 c-0.905-5.984,2.312-11.195,7.483-12.119c2.669-0.479,5.049,0.149,6.868,1.773c0.738,0.66,0.681,1.837-0.124,2.414l-0.1,0.071 c-0.606,0.434-1.405,0.336-1.97-0.15c-1.085-0.931-2.463-1.253-4.111-0.958c-3.941,0.705-5.439,4.805-4.881,8.49 c0.054,0.359,0.122,0.707,0.204,1.041C394.746,272.087,394.358,272.891,393.609,273.193L393.609,273.193z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M398.897,279.35c-0.004,0-0.009-0.001-0.013-0.001c-1.103-0.098-1.712-1.334-1.124-2.273 l0.136-0.217c0.295-0.47,0.822-0.729,1.376-0.69c0.474,0.032,0.976,0.002,1.501-0.092c3.441-0.616,5.02-3.82,4.993-7.076 c-0.007-0.813,0.556-1.515,1.359-1.636l0,0c0.939-0.142,1.826,0.556,1.844,1.506c0.095,5.218-2.977,9.525-7.633,10.357 C400.496,279.378,399.679,279.419,398.897,279.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M399.608,273.442c-1.704-0.149-2.974-1.297-3.435-2.936c-0.267-0.95,0.53-1.87,1.512-1.784 l0.367,0.032c0.57,0.05,1.04,0.44,1.23,0.98c0.093,0.264,0.271,0.49,0.604,0.519c0.769,0.067,0.904-1.036,0.924-1.258 c0.014-0.158,0.047-0.771-0.215-1.132c-0.257-0.354-0.433-0.759-0.395-1.195l0,0c0.125-1.423,1.923-1.995,2.83-0.891 c0.721,0.878,1.091,2.107,0.969,3.497C403.77,271.891,401.923,273.645,399.608,273.442z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M369.534,237.653L369.534,237.653c-0.881-0.077-1.532-0.853-1.455-1.734l1.213-13.866 l13.866,1.213c0.881,0.077,1.532,0.853,1.455,1.734l0,0c-0.077,0.881-0.853,1.532-1.734,1.455l-10.677-0.934l-0.934,10.677 C371.191,237.079,370.414,237.73,369.534,237.653z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M435.462,243.421L435.462,243.421c-0.881-0.077-1.532-0.853-1.455-1.734l0.934-10.677 l-10.677-0.934c-0.881-0.077-1.532-0.853-1.455-1.734l0,0c0.077-0.881,0.853-1.532,1.734-1.455l13.866,1.213l-1.213,13.866 C437.119,242.847,436.343,243.498,435.462,243.421z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M430.547,317.97l-13.866-1.213c-0.881-0.077-1.532-0.853-1.455-1.734l0,0 c0.077-0.881,0.853-1.532,1.734-1.455l10.677,0.934l0.934-10.677c0.077-0.881,0.853-1.532,1.734-1.455l0,0 c0.881,0.077,1.532,0.853,1.455,1.734L430.547,317.97z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M375.295,313.136l-13.866-1.213l1.213-13.866c0.077-0.881,0.853-1.532,1.734-1.455l0,0 c0.881,0.077,1.532,0.853,1.455,1.734l-0.934,10.677l10.677,0.934c0.881,0.077,1.532,0.853,1.455,1.734l0,0 C376.952,312.562,376.176,313.213,375.295,313.136z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M74.73,283.126L74.73,283.126c-0.541,0.047-1.019-0.353-1.066-0.895l-0.746-8.525l8.525-0.746 c0.542-0.047,1.019,0.353,1.066,0.895l0,0c0.047,0.541-0.353,1.019-0.895,1.066l-6.565,0.574l0.574,6.565 C75.672,282.602,75.271,283.079,74.73,283.126z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M115.266,279.58L115.266,279.58c-0.541,0.047-1.019-0.353-1.066-0.895l-0.574-6.565l-6.565,0.574 c-0.541,0.047-1.019-0.353-1.066-0.895l0,0c-0.047-0.541,0.353-1.019,0.895-1.066l8.525-0.746l0.746,8.525 C116.208,279.055,115.808,279.533,115.266,279.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M119.466,316.29l-8.525,0.746c-0.541,0.047-1.019-0.353-1.066-0.895l0,0 c-0.047-0.541,0.353-1.019,0.895-1.066l6.565-0.574l-0.574-6.565c-0.047-0.542,0.353-1.019,0.895-1.066l0,0 c0.541-0.047,1.019,0.353,1.066,0.895L119.466,316.29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M85.494,319.262l-8.525,0.746l-0.746-8.526c-0.047-0.541,0.353-1.019,0.895-1.066l0,0 c0.541-0.047,1.019,0.353,1.066,0.895l0.574,6.565l6.565-0.574c0.541-0.047,1.019,0.353,1.066,0.895l0,0 C86.436,318.737,86.035,319.214,85.494,319.262z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M114.583,140.948l-32.631,2.855l-0.668-7.636c-0.693-7.922,5.188-14.93,13.109-15.623 c7.922-0.693,14.93,5.188,15.623,13.109l0.388,4.437l4.708-0.412l-0.388-4.437c-0.92-10.518-10.225-18.325-20.743-17.405 c-10.518,0.92-18.325,10.225-17.405,20.743l0.672,7.68c-3.797,0.74-6.5,4.242-6.156,8.181l2.331,26.643 c0.369,4.213,4.083,7.329,8.296,6.961l36.53-3.196c4.213-0.368,7.329-4.082,6.961-8.295l-2.331-26.643 C122.51,143.696,118.796,140.579,114.583,140.948z M100.722,161.478l0.803,9.174c0.132,1.506-0.982,2.833-2.488,2.965 c-1.506,0.132-2.833-0.982-2.965-2.488l-0.803-9.174c-1.198-0.738-2.053-2.001-2.185-3.511c-0.222-2.535,1.654-4.77,4.189-4.992 c2.535-0.222,4.77,1.654,4.992,4.189C102.396,159.15,101.773,160.543,100.722,161.478z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M170.445,156.393l-3.299-5.378c-1.787,0.247-3.249,0.247-5.036,0l-3.299,5.378l-0.633-0.168 c-2.126-0.565-4.177-1.417-6.095-2.53l-0.567-0.329l1.399-5.838c0.113-0.473,0.588-0.764,1.061-0.651l0,0 c0.473,0.113,0.764,0.588,0.65,1.061l-1.092,4.554c1.425,0.776,2.923,1.398,4.467,1.856l3.222-5.254l0.583,0.095 c1.868,0.305,3.774,0.305,5.642,0l0.583-0.095l3.222,5.254c1.544-0.459,3.042-1.08,4.467-1.856l-1.434-5.985l0.48-0.344 c1.308-0.94,2.474-2.051,3.475-3.308c0.297-0.374,0.826-0.462,1.213-0.183l0,0c0.402,0.289,0.496,0.859,0.189,1.247 c-0.984,1.242-2.114,2.354-3.372,3.318l1.469,6.129l-0.566,0.329c-1.918,1.113-3.969,1.965-6.095,2.53L170.445,156.393z  M150.225,144.652c-0.277-0.317-0.545-0.643-0.802-0.978l-6.13,1.468l-0.329-0.566c-1.113-1.918-1.965-3.969-2.53-6.095 l-0.168-0.633l5.378-3.299c-0.124-0.896-0.184-1.724-0.184-2.518c0-0.793,0.061-1.622,0.184-2.518l-5.378-3.298l0.168-0.633 c0.565-2.126,1.417-4.177,2.53-6.095l0.329-0.566l6.129,1.468c1.027-1.34,2.222-2.534,3.562-3.562l-1.112-4.638 c-0.113-0.472,0.178-0.946,0.649-1.059l0.003-0.001c0.472-0.113,0.946,0.178,1.059,0.649l1.384,5.778l-0.484,0.348 c-1.536,1.106-2.883,2.453-3.988,3.989l-0.345,0.479l-5.985-1.434c-0.775,1.425-1.396,2.923-1.855,4.467l5.252,3.221l-0.095,0.583 c-0.168,1.031-0.25,1.954-0.25,2.821c0,0.869,0.082,1.791,0.25,2.821l0.095,0.582l-5.253,3.223 c0.458,1.545,1.08,3.042,1.855,4.467l5.985-1.434l0.345,0.479c0.325,0.452,0.674,0.891,1.042,1.312 c0.306,0.35,0.298,0.873-0.037,1.196l-0.032,0.031C151.115,145.05,150.549,145.022,150.225,144.652z M185.962,145.143l-2.26-0.541 c-0.473-0.113-0.764-0.588-0.651-1.061l0,0c0.113-0.472,0.588-0.764,1.061-0.651l0.976,0.234c0.775-1.425,1.396-2.923,1.855-4.467 l-5.253-3.223l0.095-0.582c0.168-1.03,0.25-1.953,0.25-2.821c0-0.868-0.082-1.79-0.25-2.821l-0.095-0.583l5.252-3.221 c-0.458-1.545-1.08-3.042-1.855-4.467l-5.985,1.434l-0.345-0.479c-1.105-1.536-2.452-2.883-3.988-3.989l-0.484-0.348l1.434-5.985 c-1.425-0.775-2.923-1.397-4.467-1.856l-3.222,5.253l-0.583-0.094c-1.869-0.303-3.775-0.303-5.644,0l-0.582,0.094l-3.222-5.252 c-0.2,0.059-0.4,0.122-0.6,0.187c-0.446,0.146-0.926-0.094-1.087-0.534l0,0c-0.17-0.463,0.071-0.985,0.539-1.138 c0.439-0.144,0.882-0.275,1.323-0.392l0.634-0.169l3.299,5.379c1.795-0.249,3.24-0.249,5.035,0l3.299-5.379l0.634,0.168 c2.126,0.566,4.177,1.418,6.095,2.53l0.566,0.329l-1.469,6.13c1.34,1.028,2.535,2.222,3.562,3.562l6.129-1.468l0.329,0.566 c1.113,1.918,1.965,3.969,2.53,6.095l0.168,0.633l-5.378,3.298c0.124,0.896,0.184,1.725,0.184,2.518 c0,0.794-0.061,1.622-0.184,2.518l5.378,3.299l-0.168,0.633c-0.565,2.126-1.417,4.177-2.53,6.095L185.962,145.143z M164.381,140.6 c-4.468-0.126-8.194-3.85-8.322-8.318c-0.129-4.503,3.236-8.264,7.579-8.765c0.525-0.061,0.99,0.35,0.99,0.879v0 c0,0.444-0.331,0.817-0.772,0.867c-3.83,0.434-6.707,4.056-5.905,8.14c0.521,2.652,2.658,4.789,5.311,5.307 c4.353,0.851,8.179-2.475,8.179-6.679c0-1.407-0.434-2.769-1.233-3.91c-0.252-0.36-0.184-0.852,0.146-1.143l0,0 c0.395-0.349,1.011-0.276,1.312,0.157c0.995,1.43,1.535,3.135,1.535,4.896C173.199,136.84,169.22,140.736,164.381,140.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M108.314,229.592l-2.131-3.474c-1.154,0.16-2.099,0.16-3.253,0l-2.131,3.474l-0.409-0.109 c-1.374-0.365-2.699-0.915-3.938-1.635l-0.366-0.213l0.904-3.772c0.073-0.305,0.38-0.494,0.685-0.42l0,0 c0.305,0.073,0.493,0.38,0.42,0.685l-0.705,2.942c0.921,0.501,1.888,0.903,2.886,1.199l2.081-3.394l0.377,0.062 c1.207,0.197,2.438,0.197,3.645,0l0.377-0.062l2.082,3.394c0.998-0.296,1.965-0.698,2.886-1.199l-0.927-3.866l0.31-0.223 c0.845-0.607,1.598-1.325,2.245-2.137c0.192-0.241,0.534-0.298,0.784-0.118l0,0c0.259,0.187,0.32,0.555,0.122,0.806 c-0.636,0.802-1.366,1.521-2.179,2.144l0.949,3.959l-0.366,0.213c-1.239,0.719-2.564,1.269-3.938,1.635L108.314,229.592z  M95.251,222.008c-0.179-0.205-0.352-0.415-0.518-0.632l-3.96,0.949l-0.212-0.366c-0.719-1.239-1.269-2.564-1.634-3.938 l-0.109-0.409l3.474-2.131c-0.08-0.579-0.119-1.114-0.119-1.627c0-0.512,0.039-1.048,0.119-1.627l-3.474-2.131l0.109-0.409 c0.365-1.374,0.915-2.698,1.634-3.938l0.212-0.366l3.96,0.949c0.663-0.866,1.435-1.637,2.301-2.301l-0.718-2.996 c-0.073-0.305,0.115-0.611,0.419-0.684l0.002-0.001c0.305-0.073,0.611,0.115,0.684,0.42l0.894,3.733l-0.313,0.225 c-0.992,0.714-1.862,1.584-2.576,2.577l-0.223,0.31l-3.867-0.926c-0.5,0.921-0.902,1.888-1.198,2.886l3.393,2.081l-0.061,0.377 c-0.109,0.666-0.161,1.262-0.161,1.823c0,0.561,0.053,1.157,0.161,1.823l0.062,0.376l-3.393,2.082 c0.296,0.998,0.698,1.965,1.198,2.886l3.867-0.926l0.223,0.31c0.21,0.292,0.435,0.576,0.673,0.848 c0.198,0.226,0.192,0.564-0.024,0.772l-0.021,0.02C95.826,222.264,95.461,222.246,95.251,222.008z M118.338,222.324l-1.46-0.349 c-0.305-0.073-0.494-0.38-0.421-0.685l0,0c0.073-0.305,0.38-0.493,0.685-0.42l0.631,0.151c0.5-0.921,0.902-1.888,1.198-2.886 l-3.393-2.082l0.062-0.376c0.108-0.665,0.161-1.262,0.161-1.823c0-0.561-0.053-1.157-0.161-1.823l-0.061-0.377l3.393-2.081 c-0.296-0.998-0.698-1.965-1.198-2.886l-3.867,0.926l-0.223-0.31c-0.714-0.992-1.584-1.863-2.576-2.577l-0.313-0.225l0.927-3.867 c-0.921-0.501-1.888-0.902-2.886-1.199l-2.081,3.393l-0.376-0.061c-1.207-0.196-2.438-0.196-3.646,0l-0.376,0.061l-2.081-3.393 c-0.129,0.038-0.259,0.079-0.387,0.121c-0.288,0.094-0.598-0.061-0.702-0.345l0,0c-0.11-0.299,0.046-0.636,0.348-0.735 c0.284-0.093,0.57-0.178,0.854-0.253l0.41-0.109l2.131,3.475c1.16-0.161,2.093-0.161,3.253,0l2.131-3.475l0.409,0.109 c1.373,0.366,2.698,0.916,3.938,1.634l0.366,0.213l-0.949,3.96c0.866,0.664,1.637,1.435,2.301,2.301l3.96-0.949l0.212,0.366 c0.719,1.239,1.269,2.564,1.634,3.938l0.109,0.409l-3.474,2.131c0.08,0.579,0.119,1.114,0.119,1.627 c0,0.513-0.039,1.048-0.119,1.627l3.474,2.131l-0.109,0.409c-0.365,1.374-0.915,2.699-1.634,3.938L118.338,222.324z  M104.397,219.389c-2.887-0.081-5.293-2.487-5.376-5.374c-0.084-2.909,2.09-5.339,4.896-5.663 c0.339-0.039,0.639,0.227,0.639,0.568l0,0c0,0.287-0.214,0.528-0.499,0.56c-2.474,0.28-4.333,2.62-3.815,5.259 c0.336,1.713,1.717,3.094,3.431,3.429c2.812,0.55,5.284-1.599,5.284-4.315c0-0.909-0.28-1.789-0.796-2.526 c-0.163-0.232-0.119-0.551,0.094-0.739l0,0c0.256-0.226,0.653-0.178,0.848,0.102c0.643,0.924,0.992,2.025,0.992,3.163 C110.093,216.96,107.522,219.478,104.397,219.389z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M76.67,206.633c11.27-51.09,62.004-89.298,99.27-89.441c42-0.161,77.793,31.992,106,34.839 c24.884,2.512,55.688-34.07,100-24.84c36,7.498,56,61.322,50,95.463c-11.135,63.358-40,101.192-80.316,108.51 c-17.663,3.206-26.005-2.381-34.684-0.757c-38.631,7.231-64.764,55.667-148,59.966C104.941,393.679,52.233,317.41,76.67,206.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M76.67,206.633c11.27-51.09,62.004-89.298,99.27-89.441 c42-0.161,77.793,31.992,106,34.839c24.884,2.512,55.688-34.07,100-24.84c36,7.498,56,61.322,50,95.463 c-11.135,63.358-40,101.192-80.316,108.51c-17.663,3.206-26.005-2.381-34.684-0.757c-38.631,7.231-64.764,55.667-148,59.966 C104.941,393.679,52.233,317.41,76.67,206.633z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__359_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 250,
    cy: 415.693,
    rx: 193.889,
    ry: 11.323
  })), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M363.45,145.827h-32.561l-23.031,263.249h32.561c9.26,0,17.452-7.533,18.262-16.793l20.093-229.663 C379.584,153.36,372.71,145.827,363.45,145.827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M356.806,145.827H246.607c-9.26,0-17.452,7.533-18.262,16.793l-20.093,229.663 c-0.81,9.26,6.064,16.793,15.324,16.793h110.199c9.26,0,17.452-7.533,18.262-16.793L372.13,162.62 C372.94,153.36,366.066,145.827,356.806,145.827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M356.806,145.827H246.607c-9.26,0-17.452,7.533-18.262,16.793l-20.093,229.663 c-0.81,9.26,6.064,16.793,15.324,16.793h110.199c9.26,0,17.452-7.533,18.262-16.793L372.13,162.62 C372.94,153.36,366.066,145.827,356.806,145.827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M356.335,151.207h-29.054c-1.714,0-3.323,1.125-3.958,2.767l0,0 c-2.349,6.07-8.297,10.227-14.633,10.227h-17.181c-6.336,0-11.558-4.158-12.845-10.227v0c-0.348-1.642-1.76-2.766-3.474-2.766 h-29.054c-6.303,0-11.859,5.109-12.411,11.412l-20.093,229.663c-0.551,6.303,4.111,11.412,10.414,11.412h110.199 c6.303,0,11.859-5.109,12.411-11.412l20.093-229.663C367.3,156.317,362.638,151.207,356.335,151.207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M328.883,275.958h-77.124c-2.287,0-3.978-1.854-3.778-4.14l0.386-4.413 c0.2-2.287,2.216-4.14,4.503-4.14h77.124c2.287,0,3.978,1.854,3.778,4.14l-0.386,4.413 C333.186,274.104,331.17,275.958,328.883,275.958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M327.217,294.998h-77.124c-2.287,0-3.978-1.854-3.778-4.14l0.386-4.413 c0.2-2.287,2.216-4.14,4.503-4.14h77.124c2.287,0,3.978,1.854,3.778,4.14l-0.386,4.413 C331.52,293.144,329.504,294.998,327.217,294.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M305.45,155.509c-0.222,2.536-2.457,4.591-4.993,4.591c-2.536,0-4.411-2.055-4.189-4.591 c0.222-2.536,2.457-4.591,4.993-4.591C303.796,150.918,305.672,152.973,305.45,155.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M303.367,155.509c-0.121,1.385-1.342,2.508-2.728,2.508c-1.385,0-2.41-1.123-2.289-2.508 c0.121-1.385,1.342-2.508,2.728-2.508C302.464,153.001,303.488,154.124,303.367,155.509z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M342.769,163.167L342.769,163.167c-0.743,0-1.293-0.602-1.228-1.345l0.215-2.459 c0.065-0.743,0.72-1.345,1.463-1.345l0,0c0.743,0,1.293,0.602,1.228,1.345l-0.215,2.459 C344.167,162.565,343.512,163.167,342.769,163.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M353.531,163.167L353.531,163.167c-0.743,0-1.293-0.602-1.228-1.345l0.505-5.771 c0.065-0.743,0.72-1.345,1.463-1.345l0,0c0.743,0,1.293,0.602,1.228,1.345l-0.505,5.771 C354.929,162.565,354.274,163.167,353.531,163.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M348.15,163.167L348.15,163.167c-0.743,0-1.293-0.602-1.228-1.345l0.36-4.115 c0.065-0.743,0.72-1.345,1.463-1.345l0,0c0.743,0,1.293,0.602,1.228,1.345l-0.36,4.115 C349.548,162.565,348.893,163.167,348.15,163.167z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M250.635,163.167h-6.755c-0.421,0-0.732-0.341-0.695-0.762l0.317-3.627 c0.037-0.421,0.408-0.762,0.828-0.762h6.755c0.421,0,0.732,0.341,0.695,0.762l-0.317,3.627 C251.426,162.826,251.056,163.167,250.635,163.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M253.767,162.183L253.767,162.183c-0.421,0-0.732-0.341-0.695-0.762l0.145-1.659 c0.037-0.421,0.408-0.762,0.828-0.762l0,0c0.421,0,0.732,0.341,0.695,0.762l-0.145,1.659 C254.559,161.842,254.188,162.183,253.767,162.183z"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7224 -0.6915 0.6915 0.7224 -73.4882 266.2137)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 294.812,
    cy: 224.633,
    rx: 33.728,
    ry: 30.904
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M294.921,223.379c-8.485,0-15.647,3.228-16.26,10.243l-0.681,7.785h30.729l0.681-7.785 C310.003,226.607,303.407,223.379,294.921,223.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M295.202,220.173c3.938,0,5.754-3.192,6.098-7.13c0.345-3.938-0.913-7.13-4.851-7.13 c-3.938,0-5.754,3.192-6.099,7.13C290.006,216.981,291.264,220.173,295.202,220.173z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M325.363,269.384c-2.096,0-3.865,0.797-4.016,2.53l-0.168,1.923h7.59l0.168-1.923 C329.088,270.181,327.459,269.384,325.363,269.384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M325.432,268.592c0.973,0,1.421-0.789,1.506-1.761c0.085-0.973-0.225-1.761-1.198-1.761 c-0.973,0-1.421,0.789-1.506,1.761C324.149,267.804,324.46,268.592,325.432,268.592z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M301.994,314.038h-30.009c-3.505,0-6.098-2.841-5.791-6.347v0c0.307-3.505,3.397-6.347,6.902-6.347 h30.009c3.505,0,6.098,2.842,5.791,6.347v0C308.589,311.197,305.499,314.038,301.994,314.038z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M298.374,384.818h-32.117c-3.704,0-6.444-3.003-6.12-6.707l2.049-23.425 c0.324-3.704,3.589-6.707,7.293-6.707h32.117c3.704,0,6.444,3.003,6.12,6.707l-2.049,23.425 C305.343,381.815,302.078,384.818,298.374,384.818z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M288.469,360.603c0.195-2.229-1.454-4.036-3.683-4.036c-2.229,0-4.194,1.807-4.389,4.036 c-0.116,1.327,0.431,2.495,1.356,3.23l-0.706,8.066c-0.116,1.324,0.863,2.397,2.187,2.397c1.324,0,2.491-1.073,2.607-2.397 l0.706-8.066C287.602,363.098,288.353,361.931,288.469,360.603z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M301.881,352.855h-4.139l1.014-11.59c0.609-6.965-4.561-12.631-11.526-12.631 s-13.127,5.666-13.736,12.631l-1.014,11.59h-4.139l1.014-11.59c0.809-9.247,8.99-16.77,18.237-16.77s16.112,7.523,15.303,16.77 L301.881,352.855z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M325.871,287.134l0.097-1.112c0.1-1.137-0.744-2.061-1.881-2.061c-1.137,0-2.142,0.925-2.241,2.061 l-0.097,1.112c-0.454,0-0.854,0.368-0.893,0.822l-0.259,2.956c-0.04,0.454,0.296,0.822,0.75,0.822h4.12 c0.454,0,0.854-0.368,0.894-0.822l0.259-2.956C326.66,287.502,326.325,287.134,325.871,287.134z M324.043,284.469 c0.856,0,1.491,0.696,1.417,1.552l-0.097,1.112h-3.105l0.097-1.112C322.43,285.165,323.187,284.469,324.043,284.469z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M263.847,288.318l-1.438-0.297c-0.17-0.035-0.258-0.214-0.187-0.382l0.599-1.416 c0.129-0.304-0.241-0.529-0.474-0.288l-1.087,1.12c-0.129,0.133-0.336,0.133-0.441,0l-0.891-1.12 c-0.191-0.24-0.6-0.016-0.525,0.288l0.351,1.416c0.042,0.168-0.077,0.347-0.254,0.382l-1.49,0.297 c-0.32,0.064-0.359,0.513-0.05,0.577l1.438,0.297c0.17,0.035,0.258,0.214,0.187,0.382l-0.599,1.416 c-0.129,0.304,0.241,0.529,0.474,0.288l1.087-1.12c0.129-0.133,0.336-0.133,0.441,0l0.891,1.12 c0.191,0.241,0.6,0.016,0.525-0.288l-0.351-1.416c-0.042-0.168,0.077-0.347,0.254-0.382l1.49-0.297 C264.117,288.831,264.156,288.381,263.847,288.318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M273.31,288.318l-1.438-0.297c-0.17-0.035-0.258-0.214-0.187-0.382l0.599-1.416 c0.129-0.304-0.241-0.529-0.474-0.288l-1.087,1.12c-0.129,0.133-0.335,0.133-0.441,0l-0.891-1.12 c-0.191-0.24-0.6-0.016-0.525,0.288l0.351,1.416c0.042,0.168-0.078,0.347-0.254,0.382l-1.49,0.297 c-0.32,0.064-0.359,0.513-0.051,0.577l1.438,0.297c0.17,0.035,0.258,0.214,0.187,0.382l-0.599,1.416 c-0.129,0.304,0.241,0.529,0.474,0.288l1.087-1.12c0.129-0.133,0.335-0.133,0.441,0l0.891,1.12 c0.191,0.241,0.6,0.016,0.525-0.288l-0.351-1.416c-0.042-0.168,0.078-0.347,0.254-0.382l1.49-0.297 C273.58,288.831,273.619,288.381,273.31,288.318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M282.773,288.318l-1.438-0.297c-0.17-0.035-0.258-0.214-0.187-0.382l0.599-1.416 c0.129-0.304-0.241-0.529-0.474-0.288l-1.087,1.12c-0.129,0.133-0.336,0.133-0.441,0l-0.891-1.12 c-0.191-0.24-0.6-0.016-0.525,0.288l0.351,1.416c0.042,0.168-0.077,0.347-0.254,0.382l-1.49,0.297 c-0.32,0.064-0.359,0.513-0.051,0.577l1.438,0.297c0.17,0.035,0.258,0.214,0.187,0.382l-0.599,1.416 c-0.129,0.304,0.241,0.529,0.474,0.288l1.087-1.12c0.129-0.133,0.336-0.133,0.441,0l0.891,1.12 c0.191,0.241,0.6,0.016,0.525-0.288l-0.351-1.416c-0.042-0.168,0.077-0.347,0.254-0.382l1.49-0.297 C283.043,288.831,283.082,288.381,282.773,288.318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M292.237,288.318l-1.438-0.297c-0.17-0.035-0.258-0.214-0.187-0.382l0.599-1.416 c0.129-0.304-0.241-0.529-0.474-0.288l-1.087,1.12c-0.129,0.133-0.336,0.133-0.441,0l-0.891-1.12 c-0.191-0.24-0.6-0.016-0.525,0.288l0.351,1.416c0.042,0.168-0.077,0.347-0.254,0.382l-1.49,0.297 c-0.32,0.064-0.359,0.513-0.05,0.577l1.438,0.297c0.17,0.035,0.258,0.214,0.187,0.382l-0.599,1.416 c-0.129,0.304,0.241,0.529,0.474,0.288l1.087-1.12c0.129-0.133,0.336-0.133,0.441,0l0.891,1.12 c0.191,0.241,0.6,0.016,0.525-0.288l-0.351-1.416c-0.042-0.168,0.077-0.347,0.254-0.382l1.49-0.297 C292.506,288.831,292.546,288.381,292.237,288.318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M301.7,288.318l-1.438-0.297c-0.17-0.035-0.258-0.214-0.187-0.382l0.599-1.416 c0.129-0.304-0.241-0.529-0.474-0.288l-1.087,1.12c-0.129,0.133-0.336,0.133-0.441,0l-0.891-1.12 c-0.191-0.24-0.6-0.016-0.525,0.288l0.351,1.416c0.042,0.168-0.077,0.347-0.254,0.382l-1.49,0.297 c-0.32,0.064-0.359,0.513-0.051,0.577l1.438,0.297c0.17,0.035,0.258,0.214,0.187,0.382l-0.599,1.416 c-0.128,0.304,0.241,0.529,0.474,0.288l1.087-1.12c0.129-0.133,0.335-0.133,0.441,0l0.891,1.12 c0.191,0.241,0.6,0.016,0.525-0.288l-0.351-1.416c-0.042-0.168,0.078-0.347,0.254-0.382l1.49-0.297 C301.969,288.831,302.009,288.381,301.7,288.318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M311.163,288.318l-1.438-0.297c-0.17-0.035-0.258-0.214-0.187-0.382l0.599-1.416 c0.128-0.304-0.241-0.529-0.474-0.288l-1.087,1.12c-0.129,0.133-0.335,0.133-0.441,0l-0.891-1.12 c-0.191-0.24-0.6-0.016-0.525,0.288l0.351,1.416c0.042,0.168-0.078,0.347-0.254,0.382l-1.49,0.297 c-0.32,0.064-0.359,0.513-0.051,0.577l1.438,0.297c0.17,0.035,0.258,0.214,0.187,0.382l-0.599,1.416 c-0.129,0.304,0.241,0.529,0.474,0.288l1.087-1.12c0.129-0.133,0.336-0.133,0.441,0l0.891,1.12 c0.191,0.241,0.6,0.016,0.525-0.288l-0.351-1.416c-0.042-0.168,0.077-0.347,0.254-0.382l1.49-0.297 C311.432,288.831,311.472,288.381,311.163,288.318z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M288.353,267.612h-17.768c-1.104,0-2.077,0.895-2.174,1.999c-0.097,1.104,0.72,1.999,1.824,1.999 h17.768c1.104,0,2.077-0.895,2.174-1.999C290.274,268.507,289.457,267.612,288.353,267.612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M306.39,267.612h-10.31c-1.104,0-2.077,0.895-2.174,1.999c-0.097,1.104,0.72,1.999,1.824,1.999 h10.31c1.104,0,2.077-0.895,2.174-1.999C308.311,268.507,307.494,267.612,306.39,267.612z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M320.001,358.264c-6.699,2.675-12.572,6.577-16.592,11.014c-2.357-2.006-5.708-3.399-9.725-4.036 l-0.471-0.075l-0.206,2.359l0.263,0.099c3.965,1.498,7.192,4.156,9.333,7.685l0.336,0.555l0.372-0.595 c4.12-6.596,10.128-12.122,16.916-15.56l0.23-0.117l0.137-1.568L320.001,358.264z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Policy"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M230.645,161.374c-1.249,2.197-2.073,4.648-2.301,7.245l-14.892,170.221h46.077l9.258-35.493 l-3.047-35.493l9.258-35.493l-3.047-35.493l9.258-35.493H230.645z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "267.951,186.868 277.208,151.374 160.684,151.374 151.426,186.868 154.474,222.361  145.216,257.854 148.263,293.348 139.005,328.841 255.529,328.841 264.787,293.348 261.74,257.854 270.997,222.361  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    points: "267.951,186.868 277.208,151.374 160.684,151.374 151.426,186.868  154.474,222.361 145.216,257.854 148.263,293.348 139.005,328.841 255.529,328.841 264.787,293.348 261.74,257.854  270.997,222.361  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "267.95,186.868 151.426,186.868 160.684,151.374 277.208,151.374  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "261.74,257.854 145.216,257.854 154.474,222.361 270.998,222.361  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    points: "255.529,328.841 139.005,328.841 148.263,293.348 264.787,293.348  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M252.358,201.7c-1.001,0.313-2.283,0.501-3.68,0.501c-2.057,0-3.865-0.407-4.893-1.02 c-0.282-0.169-0.592-0.253-0.902-0.253l0,0c-0.288,0-0.575,0.081-0.841,0.226c-0.02,0.011-0.042,0.015-0.061,0.027h0l0,0 c-0.011,0.007-0.025,0.012-0.036,0.019c-0.381,0.222-0.861,0.417-1.421,0.574c-0.961,0.269-2.149,0.428-3.435,0.428 c-0.349,0-0.692-0.012-1.024-0.034c-0.997-0.068-1.906-0.232-2.656-0.466c-0.131-0.041-0.263-0.065-0.392-0.074 c-0.907-0.06-1.722,0.636-1.722,1.598v0v1.084h-45.291c-3.505,0-6.347,2.841-6.347,6.347v6.396c0,3.505,2.842,6.347,6.347,6.347 h51.527c0.114,0,0.224-0.011,0.337-0.017c0.556,0.46,1.135,0.919,1.748,1.384c0.734,0.556,1.507,1.12,2.317,1.708 c0.564,0.409,1.338,0.409,1.902,0c6.479-4.699,10.639-7.94,10.639-16.845v-6.403C254.473,202.126,253.408,201.372,252.358,201.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M236.546,219.875h-51.527c-3.505,0-6.347-2.841-6.347-6.347v-6.396 c0-3.505,2.841-6.347,6.347-6.347h51.527c3.505,0,6.347,2.841,6.347,6.347v6.396 C242.893,217.033,240.051,219.875,236.546,219.875z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M247.694,198.677c-2.057,0-3.864-0.407-4.893-1.02c-0.565-0.337-1.239-0.337-1.804,0 c-1.028,0.613-2.835,1.02-4.893,1.02c-1.398,0-2.679-0.188-3.68-0.5c-1.049-0.328-2.115,0.425-2.115,1.525v6.403 c0,8.905,4.16,12.146,10.639,16.845c0.564,0.409,1.338,0.409,1.902,0c6.479-4.699,10.639-7.94,10.639-16.845v-6.403 c0-1.1-1.065-1.853-2.115-1.525C250.373,198.489,249.092,198.677,247.694,198.677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M247.694,198.677c-2.057,0-3.864-0.407-4.893-1.02 c-0.565-0.337-1.239-0.337-1.804,0c-1.028,0.613-2.835,1.02-4.893,1.02c-1.398,0-2.679-0.188-3.68-0.5 c-1.049-0.328-2.115,0.425-2.115,1.525v6.403c0,8.905,4.16,12.146,10.639,16.845c0.564,0.409,1.338,0.409,1.902,0 c6.479-4.699,10.639-7.94,10.639-16.845v-6.403c0-1.1-1.065-1.853-2.115-1.525 C250.373,198.489,249.092,198.677,247.694,198.677z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M240.997,197.657c-1.028,0.613-2.835,1.02-4.893,1.02 c-1.398,0-2.679-0.188-3.68-0.5c-1.049-0.328-2.115,0.425-2.115,1.524v6.404c0,8.905,4.16,12.146,10.639,16.845 c0.282,0.204,0.616,0.307,0.951,0.307v-25.853C241.589,197.404,241.279,197.488,240.997,197.657z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M251.186,204.357c-4.187,1.732-7.77,4.259-10.121,7.133c-1.64-1.299-3.889-2.201-6.527-2.614 l-0.309-0.048v1.528l0.176,0.064c2.653,0.97,4.893,2.692,6.48,4.977l0.249,0.359l0.207-0.385 c2.295-4.272,5.873-7.851,10.074-10.077l0.143-0.076v-1.015L251.186,204.357z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M275.151,161.355h-4.421c-2.452,0-4.265-1.987-4.051-4.439l0.387-4.421 c0.215-2.452,2.376-4.439,4.828-4.439h4.421c2.452,0,4.265,1.988,4.051,4.439l-0.387,4.421 C279.764,159.368,277.603,161.355,275.151,161.355z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "276.988,152.486 276.029,151.434 273.614,153.654 271.588,151.434 270.444,152.486  272.47,154.706 270.056,156.926 271.016,157.978 273.43,155.758 275.456,157.978 276.6,156.926 274.574,154.706  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B55B52"
    },
    d: "M176.372,199.494c2.563,2.787,5.012,5.674,7.43,8.588c2.421,2.911,4.782,5.874,7.114,8.863 c0.102,0.13,0.061,0.077,0.085,0.116c0.011,0.017,0.013,0.045,0.027,0.059c0.026,0.029,0.04,0.077,0.071,0.103 c0.046,0.074,0.113,0.127,0.18,0.197c0.142,0.127,0.336,0.224,0.552,0.264c0.107,0.016,0.22,0.032,0.335,0.02 c0.062,0.008,0.117-0.011,0.182-0.013c0.034,0.001,0.059-0.017,0.092-0.021c0.051-0.022,0.019,0.023,0.157-0.059l2.505-1.358 c3.36-1.779,6.747-3.518,10.25-5.079l2.928,3.626c-2.822,2.597-5.761,5.845-8.727,8.225l-2.24,1.761 c-0.057,0.052-0.298,0.21-0.449,0.311c-0.173,0.111-0.342,0.231-0.525,0.329c-0.363,0.2-0.729,0.4-1.118,0.554 c-0.768,0.332-1.588,0.543-2.419,0.671c-1.667,0.248-3.399,0.08-5.016-0.499c-0.806-0.29-1.587-0.677-2.298-1.171 c-0.364-0.236-0.697-0.513-1.029-0.792c-0.167-0.139-0.316-0.294-0.472-0.445l-0.398-0.403c-2.646-2.714-5.263-5.454-7.821-8.246 c-2.56-2.79-5.09-5.605-7.506-8.521L176.372,199.494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B55B52"
    },
    d: "M203.99,213.382l2.331-7.487l6.136,3.058c0,0-0.894,5.463-5.361,6.41L203.99,213.382z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B55B52"
    },
    points: "208.783,203.818 214.317,205.342 212.458,208.952 206.322,205.894  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B55B52"
    },
    d: "M144.094,201.534c-0.668,3.181-1.484,6.326-2.339,9.462c-0.851,3.137-1.78,6.255-2.746,9.364 l-0.36,1.166l-0.18,0.583c-0.038,0.127-0.063,0.159-0.097,0.244c-0.11,0.295-0.176,0.615-0.189,0.951 c-0.017,0.666,0.141,1.407,0.577,2.051c0.036,0.104,0.381,0.466,0.65,0.758l0.83,0.902l1.637,1.833 c1.078,1.237,2.152,2.478,3.172,3.783l-3.485,4.034c-1.439-0.819-2.823-1.702-4.204-2.589l-2.051-1.353l-1.014-0.691 c-0.345-0.24-0.622-0.401-1.174-0.858c-1.902-1.613-3.323-3.903-3.844-6.446c-0.266-1.269-0.331-2.592-0.183-3.902 c0.039-0.314,0.098-0.68,0.146-0.949l0.106-0.601l0.212-1.202c0.561-3.207,1.159-6.405,1.834-9.585 c0.672-3.18,1.383-6.351,2.241-9.486L144.094,201.534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B55B52"
    },
    d: "M141.625,232.346l4.126-2.11l1.82,7.013c0,0-3.311,1.269-5.874-0.361L141.625,232.346z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B55B52"
    },
    points: "151.452,227.993 151.639,234.426 147.032,237.439 145.434,230.372  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M164.942,168.469c0.101,0.496,0.445,0.844,0.769,0.778c0.324-0.066,0.505-0.521,0.404-1.017 s-0.445-0.844-0.769-0.778C165.023,167.518,164.842,167.973,164.942,168.469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A02724"
    },
    d: "M165.342,169.322c0,0,1.708,2.63,3.229,3.757c-0.711,0.997-2.277,0.926-2.277,0.926 L165.342,169.322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M162.568,166.085c-0.072,0-0.145-0.026-0.202-0.079c-0.12-0.111-0.128-0.299-0.016-0.42 c1.115-1.207,2.468-0.992,2.527-0.983c0.162,0.028,0.27,0.181,0.243,0.343c-0.028,0.161-0.183,0.269-0.341,0.243l0,0 c-0.045-0.007-1.103-0.162-1.992,0.8C162.728,166.053,162.648,166.085,162.568,166.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B55B52"
    },
    d: "M150.521,175.44c1.103,4.587,2.204,12.992-1.733,16.052c0,0,1.538,4.653,11.995,4.653 c11.498,0,5.495-2.997,5.495-2.997c-6.275-1.221-6.114-6.672-5.021-10.236L150.521,175.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M147.563,192.343c-0.685-1.275-1.44-2.733,0.121-3.19c1.717-0.503,12.748-1.435,15.988-0.491 c-0.996,1.771,0.69,3.948,0.69,3.948L147.563,192.343z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B55B52"
    },
    points: "156.696,406.919 163.911,406.919 164.629,392.398 157.415,392.398  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B55B52"
    },
    points: "110.913,404.919 118.22,405.305 122.661,391 115.353,390.613  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M117.997,404.727l-6.885-1.491c-0.25-0.054-0.505,0.073-0.612,0.306l-2.39,5.185 c-0.248,0.538,0.08,1.169,0.661,1.284c2.412,0.479,3.611,0.591,6.638,1.246c1.863,0.403,6.067,1.428,8.64,1.985 c2.516,0.545,3.459-1.914,2.456-2.372c-4.498-2.055-6.377-3.865-7.595-5.551C118.691,405.016,118.364,404.807,117.997,404.727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M163.529,406.193h-6.847c-0.256,0-0.478,0.178-0.534,0.428l-1.239,5.573 c-0.128,0.578,0.31,1.125,0.902,1.115c2.47-0.042,6.039-0.187,9.144-0.187c3.63,0,6.765,0.198,11.022,0.198 c2.574,0,3.288-2.602,2.211-2.838c-4.905-1.073-8.91-1.188-13.149-3.801C164.579,406.397,164.07,406.193,163.529,406.193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M135.725,193.612c-5.445,2.589-6.925,18.284-6.925,18.284l13.47,6.224 c0,0,3.343-4.925,3.599-12.669C146.137,197.338,141.292,190.965,135.725,193.612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M143.032,203.291c-2.432,3.775-2.202,9.616-1.36,14.552l0.595,0.279c0,0,3.347-4.931,3.604-12.673 c0.015-0.484,0.013-0.965-0.004-1.433L143.032,203.291z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M173.313,193.233c0,0,6.674,7.538,0.371,54.195c-10.105,0-28.62,0-33.537,0 c-0.231-5.148,3.004-30.261-1.962-54.518c0,0,5.749-1.154,11.227-1.418c4.285-0.206,10.489-0.343,14.256,0 C168.635,191.946,173.313,193.233,173.313,193.233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FAFAFA"
    },
    d: "M173.313,193.233c0,0,6.674,7.538,0.371,54.195c-10.105,0-28.62,0-33.537,0 c-0.231-5.148,3.004-30.261-1.962-54.518c0,0,5.749-1.154,11.227-1.418c4.285-0.206,10.489-0.343,14.256,0 C168.635,191.946,173.313,193.233,173.313,193.233z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M176.244,207.493l-0.128-0.111l-6.67-3.564c-0.678,10.27,3.913,16.708,6.644,19.524 C176.466,216.762,176.457,211.572,176.244,207.493z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "164.628,392.402 164.259,399.887 157.041,399.887 157.41,392.402  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "115.351,390.617 122.661,391.004 120.368,398.377 113.058,397.991  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B55B52"
    },
    d: "M148.199,170.778c1.611,6.011,2.248,9.611,5.958,12.11c5.579,3.759,12.526-0.555,12.743-6.926 c0.196-5.734-2.472-14.6-8.922-15.812C151.623,158.957,146.588,164.767,148.199,170.778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M161.787,247.428c0,0-7.116,47.917-11.022,65.869c-4.278,19.658-27.216,84.698-27.216,84.698 l-11.224-2.43c0,0,14.384-53.003,17.974-80.486c1.401-10.725,3.092-28.013,5.232-42.427c2.072-13.959,4.616-25.224,4.616-25.224 H161.787z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M126.236,394.247c0.048,0.01-2.092,4.059-2.092,4.059l-12.628-2.734l1.065-3.796L126.236,394.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M126.236,394.247c0.048,0.01-2.092,4.059-2.092,4.059l-12.628-2.734l1.065-3.796 L126.236,394.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6
    },
    d: "M157.29,264.5c-8.228,1.613-7.357,32.296-6.367,48.078c2.373-11.155,5.846-32.621,8.219-47.856 C158.596,264.449,157.981,264.364,157.29,264.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M173.684,247.428c0,0,3.347,46.88,2.665,66.001c-0.709,19.888-10.139,85.009-10.139,85.009h-10.622 c0,0-0.39-63.959-0.862-83.491c-0.515-21.294-3.086-67.519-3.086-67.519H173.684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M168.253,394.207c0.049,0-0.599,4.41-0.599,4.41h-12.921l-0.349-3.936L168.253,394.207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M168.253,394.207c0.049,0-0.599,4.41-0.599,4.41h-12.921l-0.349-3.936L168.253,394.207 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M169.399,202.015c0,12.581,6.695,17.761,6.695,17.761l10.882-10.638c0,0-3.7-6.375-8.788-12.227 C171.901,189.681,169.399,193.925,169.399,202.015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M166.519,178.239c-0.276,0.771-1.001,2.078-2.822,2.599c-2.656,0.76-2.691,3.011-2.691,3.011 l0.033,0.042C163.573,183.054,165.683,180.96,166.519,178.239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M163.698,158.831c2.242-2.827-1.207-2.962-1.207-2.962c0.896-3.375-3.138-1.558-3.138-1.558 c-2.422-3.338-3.788,0.724-3.788,0.724c-2.512-2.828-2.974,1.794-2.974,1.794c-2.519-3.587-3.802,1.587-3.802,1.587 c-2.32-3.725-3.74,1.128-3.74,1.128c-4.79-1.715-2.513,3.263-2.513,3.263c-4.089,0.115-0.809,3.278-0.809,3.278 c-4.898,0.012-0.579,2.817-0.579,2.817c-3.89,2.552,0.993,3.239,0.993,3.239c-3.174,4.963,2.276,3.122,2.276,3.122 c-2.208,4.912,2.688,2.748,2.688,2.748c-0.318,4.74,2.42,3.45,3.736,2.572c0.254,0.955,0.728,1.966,1.608,2.081 c1.708,0.223,2.04-3.001,2.04-3.001s1.585,1.233,2.914,0.565c1.329-0.668,0.828-2.359,0.828-2.359s1.017,0.759,1.949,0.035 c0.57-0.443,0.573-3.626-0.154-4.745l2.603-1.019c0,0,1.932-0.272,1.069-2.819c-0.862-2.546-0.131-4.557-0.131-4.557 c2.938-1.377,0.528-3.033,0.528-3.033C167.492,159.53,163.698,158.831,163.698,158.831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B55B52"
    },
    d: "M158.425,171.03c0.409,1.578,1.446,2.934,2.53,3.741c1.632,1.214,2.85,0.019,2.734-1.827 c-0.104-1.662-1.079-4.296-2.879-4.789C159.038,167.669,157.958,169.226,158.425,171.03z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalSignature);
export default __webpack_public_path__ + "static/media/digital_signature.6851af739e55013e0d5f4dbf4e1fcfa4.svg";
export { ForwardRef as ReactComponent };